import nr1FindUserActivityDatainMetricsandEvents from 'images/nr1_screenshot-full_Find-user-activity-data-in-Metrics-and-events.webp';
import nr1FindUserActivityDatainNrql from 'images/nr1_screenshot-full_Find-user-activity-data-in-nrql.webp';
import * as React from 'react';
export default {
  nr1FindUserActivityDatainMetricsandEvents,
  nr1FindUserActivityDatainNrql,
  React
};